import React, { useState, useEffect } from 'react'
import { Theme, Skeleton, Box, CircularProgress } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { NetworkType } from '@3m5/sm_publish-frontend-api'

const useStyles = makeStyles((theme: Theme) => ({
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: 2,
    display: 'inline',
    verticalAlign: 'bottom',
    paddingBottom: theme.spacing(2),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    paddingBottom: theme.spacing(2),
  },
}))

export interface IImageModuleProps extends React.ImgHTMLAttributes<HTMLImageElement>{
  data?: string
  networkType?: NetworkType
  view?: string
}

const Image: React.FC<IImageModuleProps> = (props) => {
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)

  // Reset loading state when image URL changes
  useEffect(() => {
    if (props.data) {
      setIsLoading(true)
      setHasError(false)
    }
  }, [props.data])

  const handleImageLoad = () => {
    setIsLoading(false)
    setHasError(false)
  }

  const handleImageError = () => {
    setIsLoading(false)
    setHasError(true)
  }

  return (
    <div>
      {props.data && (
        <>
          {isLoading && !hasError && (
            <Box className={classes.loadingContainer}>
              <CircularProgress />
            </Box>
          )}
          <img 
            {...props} 
            className={classes.img} 
            src={props.data}
            onLoad={handleImageLoad}
            onError={handleImageError}
            style={{ 
              ...props.style,
              display: isLoading ? 'none' : 'inline'
            }}
          />
        </>
      )}
    </div>
  )
}

export default Image
